// extracted by mini-css-extract-plugin
module.exports =  {"seller-info":"NVxRBOE","sellerInfo":"NVxRBOE","compact-view":"i3tHPye","compactView":"i3tHPye","separation-ellipse":"Uf9zgTh","separationEllipse":"Uf9zgTh"};